module.exports = __webpack_public_path__ + "static/media/tractor.bcfe86c0.svg";